import React from "react";
import PropTypes from "prop-types";
import { useForm } from "react-hook-form";
import { updateProfile } from "@/_actions/userActions";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { PatternFormat } from "react-number-format";

export default function PersonalInformation(props) {
  const { data, callBack, cancel } = props;
  const { email } = data;

  const form = useForm({
    defaultValues: {
      first_name: data.first_name || "",
      last_name: data.last_name || "",
      mobile: data?.contact?.mobile || "",
      whatsapp: data?.contact?.whatsapp || "",
    },
  });

  const onSubmit = async (values) => {
    const { first_name, last_name, mobile, whatsapp } = values;
    const format = {
      first_name,
      last_name,
      contact: {
        mobile,
        whatsapp,
      },
    };
    try {
      await updateProfile(format);
      if (callBack) {
        callBack(format);
      }
    } catch (err) {
      $log.error(err);
    }
  };

  return (
    <div>
      <Form {...form}>
        <form
          onSubmit={form.handleSubmit(onSubmit)}
          data-splitbee-event="account-edit-contact-save"
          className="space-y-4"
        >
          <FormField
            control={form.control}
            name="first_name"
            render={({ field }) => (
              <FormItem className="m-2">
                <FormLabel htmlFor="first_name">Nombre(s)</FormLabel>
                <FormControl>
                  <Input id="first_name" placeholder="Abc" {...field} />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name="last_name"
            render={({ field }) => (
              <FormItem className="m-2">
                <FormLabel htmlFor="last_name">Apellido</FormLabel>
                <FormControl>
                  <Input id="last_name" {...field} />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name="mobile"
            render={({ field }) => (
              <FormItem className="m-2">
                <FormLabel htmlFor="mobile">Teléfono</FormLabel>
                <FormControl>
                  <PatternFormat
                    id="mobile"
                    format="## #### ####"
                    customInput={Input}
                    value={field.value}
                    onValueChange={({ value }) => field.onChange(value)}
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name="whatsapp"
            render={({ field }) => (
              <FormItem className="m-2">
                <FormLabel htmlFor="whatsapp">Whatsapp</FormLabel>
                <FormControl>
                  <PatternFormat
                    id="whatsapp"
                    format="## #### ####"
                    customInput={Input}
                    value={field.value}
                    onValueChange={({ value }) => field.onChange(value)}
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />

          <div className="m-2">
            <Label htmlFor="email" className="block text-sm font-medium">
              Email (no se puede editar)
            </Label>
            <Input id="email" name="email" value={email || ""} disabled className="opacity-50" />
          </div>

          <div className="m-2 mt-3 flex gap-2">
            <Button type="button" variant="outline" onClick={cancel}>
              Cancelar
            </Button>
            <Button type="submit" disabled={form.formState.isSubmitting}>
              Guardar
            </Button>
          </div>
        </form>
      </Form>
    </div>
  );
}

PersonalInformation.propTypes = {
  data: PropTypes.shape({
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    email: PropTypes.string,
    contact: PropTypes.shape({
      mobile: PropTypes.string,
      whatsapp: PropTypes.string,
    }),
  }).isRequired,
  callBack: PropTypes.func,
  cancel: PropTypes.func,
};

PersonalInformation.defaultProps = {
  callBack: null,
  cancel: null,
};
